import { onCLS, onINP, onLCP, type Metric } from 'web-vitals'
import { analytics } from '@/analytics/client'

let didRegister = false

function reportMetric(metric: Metric) {
  analytics.track('web_vitals', {
    metric_name: metric.name,
    metric_value: metric.value,
    metric_rating: metric.rating,
    metric_delta: metric.delta,
    metric_id: metric.id,
    navigation_type: metric.navigationType,
  })
}

/** Registers Core Web Vitals listeners; events are no-ops until PostHog is initialized. */
export function registerWebVitalsReporting() {
  if (didRegister || typeof window === 'undefined') {
    return
  }

  didRegister = true
  onLCP(reportMetric)
  onCLS(reportMetric)
  onINP(reportMetric)
}
